import { SelectArrayInputProps } from 'react-admin';
import { SelectArrayReferneceInput } from './common';
import { Resources } from '../resources/resource';

export function SelectUserGroupInput(props: SelectArrayInputProps & { multiple?: boolean }) {
  return <SelectArrayReferneceInput {...props} reference={Resources.users + '/groups'} />;
}
